import { useTranslation } from "react-i18next";
import styles from "./StatsOverview.module.scss";
import BasicRangeShortcuts from "../DatePicker/DatePicker";

const StatsOverview = () => {
  const { i18n } = useTranslation();

  const statsData = [
    { value: 123, label: i18n.t("statsMessages"), color: "green" },
    { value: 43, label: i18n.t("statsAIMessages"), color: "blue" },
    { value: 16, label: i18n.t("statsDealogues"), color: "orange" },
    {
      value: 234,
      label: i18n.t("statsTotalDialogues"),
      color: "red",
    },
    {
      value: 234,
      label: i18n.t("statsTotalCampaigns"),
      color: "teal",
    },
    {
      value: 23,
      label: i18n.t("statsAICampaigns"),
      color: "pink",
    },
    {
      value: 13,
      label: i18n.t("statsSuccessfulDialogues"),
      color: "purple",
    },
    {
      value: "89%",
      label: i18n.t("statsSuccessfulDialoguesPercentage"),
      color: "yellow",
    },
  ];
  return (
    <div className={styles.statsOverview}>
      {statsData.map((stat, index) => (
        <div key={index} className={`${styles.statCard} ${styles[stat.color]}`}>
          <p className={styles.statLabel}>{stat.label}</p>
          <p className={styles.statValue}>{stat.value}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;
